import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    schoolAnalyticsRoot: {
        width: '100%',
        height: '100%',
        overflow: 'auto'
    }
}));
